<h1 mat-dialog-title>
  {{ data.type === "followers" ? "Followers" : "Following" }}
</h1>

<table
  mat-table
  *ngIf="data.followUsers && data.followUsers.length > 0"
  [dataSource]="data.followUsers"
  class="w-100"
>
  <ng-container matColumnDef="user">
    <th mat-header-cell *matHeaderCellDef>User</th>
    <td mat-cell *matCellDef="let followUser">
      <img class="profilePicture" [src]="followUser.profile_picture" />
      {{ followUser.display_name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="duration">
    <th mat-header-cell *matHeaderCellDef>Duration</th>
    <td mat-cell *matCellDef="let followUser">
      {{ followUser.start_following | followDuration }}
    </td>
  </ng-container>

  <ng-container matColumnDef="open">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let followUser">
      <button
        [routerLink]="'/u/' + followUser.uid"
        mat-icon-button
        color="primary"
        aria-label="Example icon button with a home icon"
      >
        <mat-icon>open_in_new</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<p
  *ngIf="data.followUsers && data.followUsers.length === 0"
  class="text-center"
>
  {{
    data.type === "followers"
      ? "You have no followers."
      : "You don't follow anyone."
  }}
</p>

<div class="d-flex justify-content-center pt-3">
  <mat-spinner *ngIf="isLoading" color="primary" [diameter]="32"></mat-spinner>
</div>

<div class="d-flex justify-content-center py-2">
  <button
    *ngIf="!isLoading && !hasLoadedAll"
    mat-raised-button
    color="accent"
    (click)="loadMoreFollowing()"
  >
    Load More
  </button>
</div>
